/*
  ANVIL CUSTOM JS
  ----------------------------------------------------------------------------
  Zentrale Datei für alle eigenen JavaScript-Anpassungen am Impact-Theme.
  Theme-Updates fassen diese Datei nie an – eigener Code ist hier sicher.

  Regeln (siehe CLAUDE.md, „Update-sichere Anpassungen"):
  - Eigenes JS zuerst hier ergänzen, NICHT in assets/theme.js.
  - Impact bietet Events/Hooks für Integrationen, siehe
    https://support.maestrooo.com/category/300-technical-documentation
  - Größere Blöcke mit einem Kommentar versehen (was/warum).
*/

/*
  Produkt-Konfigurator (snippets/anvil-product-configurator.liquid)
  ----------------------------------------------------------------------------
  Die Variantenwahl selbst erledigt Impacts <variant-picker>. Hier nur:
  1. „Sample anhören“: Klangbeispiel abspielen/stoppen (eine Audio-Instanz).
  2. „Selbst einstellen“ offen halten: Impact rendert die Section nach jeder
     Auswahl neu; der Aufklapp-Zustand wird gemerkt und wiederhergestellt.
  Alles per Event-Delegation, damit es auch nach dem Rerender funktioniert.
*/
(function () {
  var audio = null;
  var activeButton = null;

  function stopSample() {
    if (audio) {
      audio.pause();
      audio = null;
    }
    if (activeButton) {
      activeButton.classList.remove('is-playing');
      activeButton.setAttribute('aria-pressed', 'false');
      activeButton = null;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-anvil-sound]');
    if (!button) return;

    event.preventDefault();

    if (activeButton === button) {
      stopSample();
      return;
    }

    stopSample();
    audio = new Audio(button.getAttribute('data-anvil-sound'));
    activeButton = button;
    button.classList.add('is-playing');
    button.setAttribute('aria-pressed', 'true');
    audio.addEventListener('ended', stopSample);
    audio.play().catch(stopSample);
  });

  var detailsOpen = null;

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (details && details.classList && details.classList.contains('anvil-konfigurator__details')) {
      detailsOpen = details.open;
    }
  }, true);

  document.addEventListener('variant:change', function () {
    stopSample();
    if (detailsOpen === null) return;
    var details = document.querySelector('.anvil-konfigurator__details');
    if (details && detailsOpen) {
      details.open = true;
    }
  });
})();

/*
  Switch-Karten (sections/anvil-switch-cards.liquid)
  ----------------------------------------------------------------------------
  Punkte unter der wischbaren Kartenreihe (auch Discord-Stimmen und Streamer): zeigen, welche Karte gerade vorn
  ist, und springen beim Antippen zur Karte. Nur sichtbar, wenn die Reihe
  tatsächlich scrollt (Handy/Tablet); auf dem Desktop stehen alle Karten
  nebeneinander und die Punkte bleiben versteckt.
*/
(function () {
  function init(root) {
    var lists = (root || document).querySelectorAll('.anvil-switches, .anvil-discord__list, .anvil-streamers__list');

    lists.forEach(function (list) {
      var dots = list.parentElement.querySelector('[data-anvil-switch-dots]');
      if (!dots || dots.dataset.ready) return;
      dots.dataset.ready = 'true';

      var cards = list.children;
      var buttons = dots.querySelectorAll('button');

      function update() {
        var scrollable = list.scrollWidth > list.clientWidth + 2;
        dots.hidden = !scrollable;
        if (!scrollable) return;

        var index = 0;
        var best = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var distance = Math.abs(cards[i].offsetLeft - list.offsetLeft - list.scrollLeft);
          if (distance < best) {
            best = distance;
            index = i;
          }
        }
        // Ganz am Ende: letzte Karte aktiv, auch wenn sie nicht ganz links steht
        if (list.scrollLeft + list.clientWidth >= list.scrollWidth - 2) {
          index = cards.length - 1;
        }

        buttons.forEach(function (button, i) {
          var active = i === index;
          button.classList.toggle('is-active', active);
          if (active) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }

      buttons.forEach(function (button, i) {
        button.addEventListener('click', function () {
          if (!cards[i]) return;
          list.scrollTo({ left: cards[i].offsetLeft - list.offsetLeft, behavior: 'smooth' });
        });
      });

      var ticking = false;
      list.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      }, { passive: true });

      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // „Switch wählen“: zum Switch-Schritt im Konfigurator springen (gleiche Seite)
  document.addEventListener('click', function (event) {
    var wrapper = event.target.closest('[data-anvil-scroll-switch]');
    if (!wrapper || !event.target.closest('button, a')) return;

    var needle = (wrapper.getAttribute('data-anvil-step') || '').toLowerCase().trim();
    var target = null;

    if (needle) {
      var steps = document.querySelectorAll('.anvil-konfigurator__step');
      for (var i = 0; i < steps.length; i++) {
        var legend = steps[i].querySelector('legend');
        if (legend && legend.textContent.toLowerCase().indexOf(needle) !== -1) {
          target = steps[i];
          break;
        }
      }
    }

    target = target || document.querySelector('.anvil-konfigurator') || document.querySelector('.shopify-section--main-product');
    if (!target) return;

    event.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

    if (target.classList.contains('anvil-konfigurator__step')) {
      target.classList.remove('anvil-is-target');
      void target.offsetWidth;
      target.classList.add('anvil-is-target');
      var first = target.querySelector('input:checked') || target.querySelector('input');
      if (first) first.focus({ preventScroll: true });
    }
  });
})();

/*
  Sprung-Buttons auf derselben Seite (data-anvil-scroll-to="<CSS-Selektor>")
  ----------------------------------------------------------------------------
  Hilfe-Zeile im Konfigurator („Switches vergleichen“, „Switch-Tester“): scrollt
  zur Ziel-Section. Buttons starten mit „hidden“ und werden nur eingeblendet,
  wenn es das Ziel auf der Seite gibt – so entsteht nie ein Button ins Leere.
  Nach jedem Rerender von Impact (neue Knoten im DOM) erneut prüfen.
*/
(function () {
  function reveal() {
    document.querySelectorAll('[data-anvil-scroll-to]').forEach(function (button) {
      var selector = button.getAttribute('data-anvil-scroll-to');
      var target = null;
      try { target = document.querySelector(selector); } catch (e) { target = null; }
      button.hidden = !target;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-anvil-scroll-to]');
    if (!button) return;

    var target = null;
    try { target = document.querySelector(button.getAttribute('data-anvil-scroll-to')); } catch (e) { target = null; }
    if (!target) return;

    event.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  // Impact rendert den Produktbereich nach jeder Variantenwahl neu: neue Buttons prüfen
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      reveal();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/*
  Voraussichtliches Lieferdatum (snippets/anvil-trust.liquid, data-anvil-delivery)
  ----------------------------------------------------------------------------
  Zählt ab heute data-min bzw. data-max Werktage (Mo–Fr, Feiertage nicht
  berücksichtigt) und setzt die Daten in die Vorlage ([von], [bis]). Ohne
  JavaScript bleibt der Liquid-Fallback (allgemeine Lieferzeit) stehen.
*/
(function () {
  var TAGE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function plusWerktage(start, anzahl) {
    var datum = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var gezaehlt = 0;
    while (gezaehlt < anzahl) {
      datum.setDate(datum.getDate() + 1);
      var tag = datum.getDay();
      if (tag !== 0 && tag !== 6) gezaehlt++;
    }
    return datum;
  }

  function format(datum) {
    return TAGE[datum.getDay()] + ', ' + datum.getDate() + '.' + (datum.getMonth() + 1) + '.';
  }

  function render() {
    document.querySelectorAll('[data-anvil-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var vorlage = el.getAttribute('data-template') || '';
      if (!min || !max || vorlage.indexOf('[von]') === -1) return;

      var heute = new Date();
      var text = vorlage
        .replace('[von]', format(plusWerktage(heute, min)))
        .replace('[bis]', format(plusWerktage(heute, max)));
      // Nur bei Änderung schreiben – sonst löst der MutationObserver unten endlos neu aus
      if (el.textContent !== text) el.textContent = text;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // Impact rendert den Produktbereich nach jeder Variantenwahl neu: dann wieder den Fallback ersetzen
  var wartet = false;
  new MutationObserver(function () {
    if (wartet) return;
    wartet = true;
    requestAnimationFrame(function () {
      wartet = false;
      render();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/*
  Kaufbereich: Preset zuerst, Selbstbau danach (snippets/anvil-buybox.liquid)
  ----------------------------------------------------------------------------
  Den Variantenwechsel macht Impacts <variant-picker>: Er liest die angehakten
  Radios (Keycaps, Plate, Switch), setzt das Kaufformular und rendert den Block
  serverseitig neu. Hier nur:
  1. Build-Karte: Plate- und Switch-Radio zusammen setzen, EIN Wechsel-Event.
  2. Beim Laden ohne ?variant=: Auswahl aus ?build/keycaps/plate/switch oder den
     Standard-Build setzen. Das Kaufformular bekommt die Variante sofort
     (Varianten-Tabelle aus dem Snippet, keine IDs im Code).
  3. URL (?build=…&keycaps=… bzw. plate/switch) per replaceState, Farb-Links
     mit denselben Parametern.
  4. Tabs „Fertige Builds“ / „Selbst zusammenstellen“: gewählten Tab über das Neu-Rendern
     halten; zurück zu den Builds wählt wieder einen Build (zuletzt gewählter, sonst Standard).
  5. Handy: Preis im Sticky-Warenkorb-Button (Impacts product-quick-add).
  6. Switch-Tester-Karte (eigenes Formular) und Info-Drawer ⓘ im Selbstbau: Switch-Karten beim Öffnen kopieren.
  7. Tracking: build_selected, keycaps_selected, custom_build_opened, tester_offer_opened, tester_added, info_opened.
  8. Zusammenfassung „Deine Auswahl: …“ direkt über dem Warenkorb-Button.
*/
(function () {
  var PARAMS = ['build', 'keycaps', 'plate', 'switch'];
  var modus = null;     // 'builds' | 'selbst', null = aus der Auswahl ableiten
  var lastBuild = null; // zuletzt aktiver Build, für den Wechsel zurück zu „Fertige Builds“

  function root() {
    return document.querySelector('[data-anvil-buybox]');
  }

  // Tracking-Vertrag: Diese Ereignisnamen abonniert der Custom Pixel (docs/pixel/anvil-custom-pixel.js)
  // und gibt sie an GA4 und Meta weiter. Namen und Parameter nie umbenennen; neue Ereignisse zuerst
  // in docs/TRACKING.md eintragen. Aktuell: build_selected {build}, keycaps_selected {keycaps},
  // switch_picked {switch, from}, plate_selected {plate}, case_color_selected {case, from},
  // custom_build_opened, switch_drawer_opened {from}, info_opened {from},
  // tester_offer_opened, tester_added, build_save_opened, build_saved {build}.
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  function variantTable(box) {
    try {
      var script = box.querySelector('script[data-anvil-variants]');
      return script ? JSON.parse(script.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  // Radios setzen, ohne Zwischen-Events; nur das letzte löst Impacts Wechsel aus
  var programmatisch = false; // true, während Build-Karten Plate/Switch setzen (kein eigenes Tracking-Ereignis)
  function selectInputs(inputs) {
    var changed = inputs.filter(function (input) { return input && !input.checked; });
    if (!changed.length) return false;
    changed.forEach(function (input) { input.checked = true; });
    programmatisch = true;
    try { changed[changed.length - 1].dispatchEvent(new Event('change', { bubbles: true })); } finally { programmatisch = false; }
    return true;
  }

  // Kaufformular sofort auf die Zielvariante setzen, damit der Warenkorb schon vor dem Neu-Rendern stimmt
  function presetForm(box, keycaps, plate, sw) {
    var entry = variantTable(box)[keycaps + '|' + plate + '|' + sw];
    var form = document.forms[box.getAttribute('data-form-id')];
    if (entry && entry.available && form && form.id) {
      form.id.value = entry.id;
    }
  }

  function currentParams(box) {
    var build = box.getAttribute('data-build');
    var values = { keycaps: box.getAttribute('data-keycaps') };
    if (build) {
      values.build = build;
    } else {
      values.plate = box.getAttribute('data-plate');
      values['switch'] = box.getAttribute('data-switch');
    }
    return values;
  }

  function applyParams(url, values) {
    PARAMS.forEach(function (key) { url.searchParams.delete(key); });
    PARAMS.forEach(function (key) {
      if (values[key]) url.searchParams.set(key, values[key]);
    });
    return url;
  }

  function syncUrlAndLinks() {
    var box = root();
    if (!box) return;
    var values = currentParams(box);

    var url = applyParams(new URL(window.location.href), values);
    window.history.replaceState(window.history.state, '', url.toString());

    // Farb-Links: Auswahl mitnehmen (ohne ?variant=, die IDs gehören zum anderen Produkt); ?view= für die Vorschau behalten
    var view = new URL(window.location.href).searchParams.get('view');
    box.querySelectorAll('[data-anvil-color-link]').forEach(function (link) {
      var target = applyParams(new URL(link.getAttribute('href'), window.location.origin), values);
      target.searchParams.delete('variant');
      if (view) target.searchParams.set('view', view);
      link.setAttribute('href', target.pathname + target.search);
    });
  }

  // „Build Taktil · Keycaps Standard · Plague Black“ aus Auswahl-Zeile und Gehäuse (data-anvil-build-info)
  function auswahlText(box) {
    var el = box.querySelector('.anvil-konfigurator__auswahl-text');
    var text = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    var script = box.querySelector('script[data-anvil-build-info]');
    try {
      var info = script ? JSON.parse(script.textContent) : null;
      if (info && info.gehaeuse) text = text ? text + ' · ' + info.gehaeuse : info.gehaeuse;
    } catch (e) {}
    return text;
  }

  function auswahlLabel(box) {
    return box.getAttribute('data-build') ? box.getAttribute('data-auswahl-label') : box.getAttribute('data-auswahl-label-selbst');
  }

  // Preis der Auswahl im Warenkorb-Button (Haupt-Button und Sticky-Balken).
  // Native 75: Preis aus dem Kaufbereich (data-price), dazu Preis oben und Auswahl-Zeile unter dem Button.
  // Zubehörseiten: Preis aus der Bewertungszeile (data-anvil-preis-oben), die Impact bei jedem
  // Variantenwechsel serverseitig neu rendert.
  function syncStickyPrice() {
    var box = root();
    var oben = document.querySelector('.product-info [data-anvil-preis-oben]');
    if (!box && !oben) return;
    var price = box ? box.getAttribute('data-price') : oben.textContent.trim();
    if (!price) return;
    var info = (box || oben).closest('.product-info') || document;

    if (box) {
      info.querySelectorAll('[data-anvil-preis-oben]').forEach(function (el) {
        if (el.textContent !== price) el.textContent = price;
      });
    }

    info.querySelectorAll('.product-info__buy-buttons button[type="submit"]').forEach(function (button) {
      if (button.closest('.anvil-tester')) return;
      setButtonPrice(button, price);
      if (!box) return;

      // Direkt über „In den Warenkorb“: „Deine Auswahl: Build Taktil · …“
      var wrap = button.closest('.product-info__buy-buttons');
      var zeile = wrap.querySelector('.anvil-auswahl-unten');
      if (!zeile) {
        zeile = document.createElement('p');
        zeile.className = 'anvil-auswahl-unten';
        zeile.innerHTML = '<span class="anvil-auswahl-unten__label"></span> <span class="anvil-auswahl-unten__text"></span>';
      }
      if (button.previousElementSibling !== zeile) button.insertAdjacentElement('beforebegin', zeile);
      var label = auswahlLabel(box) || '';
      var text = auswahlText(box);
      var labelEl = zeile.querySelector('.anvil-auswahl-unten__label');
      var textEl = zeile.querySelector('.anvil-auswahl-unten__text');
      if (labelEl.textContent !== label + ':') labelEl.textContent = label + ':';
      if (textEl.textContent !== text) textEl.textContent = text;
    });
    document.querySelectorAll('.product-quick-add buy-buttons.sm\\:hidden button[type="submit"]').forEach(function (button) {
      setButtonPrice(button, price);
    });
  }

  function setButtonPrice(button, price) {
    var span = button.querySelector('.anvil-sticky-preis');
    if (!span) {
      span = document.createElement('span');
      span.className = 'anvil-sticky-preis';
      button.appendChild(span);
    }
    if (span.textContent !== price) span.textContent = price;
  }


  // Das Snippet rendert den Tab passend zur Auswahl (Selbstbau, wenn keine Build-Karte passt). Hat der Kunde
  // einen Tab gewählt, gilt der, auch wenn seine eigene Zusammenstellung zufällig einem Build entspricht.
  function syncModus() {
    var box = root();
    if (!box) return;
    if (box.getAttribute('data-build')) lastBuild = box.getAttribute('data-build');
    var wanted = modus || (box.getAttribute('data-build') === '' ? 'selbst' : 'builds');
    box.querySelectorAll('[data-anvil-modus]').forEach(function (tab) {
      var aktiv = tab.getAttribute('data-anvil-modus') === wanted;
      tab.setAttribute('aria-selected', aktiv ? 'true' : 'false');
      if (aktiv) tab.removeAttribute('tabindex'); else tab.setAttribute('tabindex', '-1');
    });
    box.querySelectorAll('[data-anvil-modus-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-anvil-modus-panel') !== wanted;
    });
  }

  function chooseModus(box, wanted) {
    var vorher = modus || (box.getAttribute('data-build') === '' ? 'selbst' : 'builds');
    modus = wanted;
    syncModus();
    if (wanted === vorher) return;

    if (wanted === 'selbst') {
      track('custom_build_opened', {});
      return;
    }

    // Zurück zu den Builds: eigene Zusammenstellung ohne passenden Build → wieder einen Build wählen,
    // damit immer sichtbar ist, was im Warenkorb landet
    if (!box.getAttribute('data-build')) {
      var handle = lastBuild || box.getAttribute('data-default-build');
      var card = handle ? box.querySelector('[data-anvil-build="' + handle.replace(/"/g, '') + '"]') : null;
      if (!card) card = box.querySelector('[data-anvil-build]');
      if (card) card.click();
    }
  }

  // Auswahl im Reiter „Selbst zusammenstellen“: Reiter festhalten. Sonst springt die Ansicht zu den Builds,
  // sobald die eigene Kombination zufällig einem Build entspricht (z. B. Seite mit ?plate=&switch= geöffnet).
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('[data-anvil-buybox] [data-anvil-modus-panel="selbst"]')) modus = 'selbst';
  });

  // Tabs: Klick und Pfeiltasten (WAI-ARIA-Tabs)
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-anvil-buybox] [data-anvil-modus]');
    if (!tab) return;
    chooseModus(tab.closest('[data-anvil-buybox]'), tab.getAttribute('data-anvil-modus'));
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('[data-anvil-buybox] [data-anvil-modus]');
    if (!tab || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
    var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-anvil-modus]'));
    var i = tabs.indexOf(tab);
    var ziel = event.key === 'Home' ? tabs[0]
      : event.key === 'End' ? tabs[tabs.length - 1]
      : tabs[(i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    event.preventDefault();
    ziel.focus();
    ziel.click();
  });

  function find(box, attr, value) {
    if (!value) return null;
    return box.querySelector('input[' + attr + '="' + value.replace(/"/g, '') + '"]');
  }

  // Beim Laden: Auswahl aus der URL oder Standard-Build
  function initialSelection() {
    var box = root();
    if (!box) return;
    var params = new URL(window.location.href).searchParams;

    if (!params.has('variant')) {
      var keycapsInput = find(box, 'data-anvil-keycaps', params.get('keycaps')) || box.querySelector('input[data-anvil-keycaps]');
      var plateInput = null;
      var switchInput = null;

      var buildHandle = params.get('build');
      if (!buildHandle && !params.get('plate') && !params.get('switch')) {
        buildHandle = box.getAttribute('data-default-build');
      }

      var card = buildHandle ? box.querySelector('[data-anvil-build="' + buildHandle.replace(/"/g, '') + '"]') : null;
      if (card) {
        plateInput = document.getElementById(card.getAttribute('data-plate-input'));
        switchInput = document.getElementById(card.getAttribute('data-switch-input'));
      } else {
        plateInput = find(box, 'data-anvil-plate', params.get('plate'));
        switchInput = find(box, 'data-anvil-switch', params.get('switch'));
      }

      var inputs = [keycapsInput, plateInput, switchInput].filter(Boolean);
      if (inputs.length) {
        var k = keycapsInput ? keycapsInput.getAttribute('data-anvil-keycaps') : box.getAttribute('data-keycaps');
        var p = plateInput ? plateInput.getAttribute('data-anvil-plate') : box.getAttribute('data-plate');
        var s = switchInput ? switchInput.getAttribute('data-anvil-switch') : box.getAttribute('data-switch');
        presetForm(box, k, p, s);
        if (selectInputs(inputs)) return; // Rest erledigt variant:change
      }
    }

    syncModus();
    syncInfoButtons();
    syncUrlAndLinks();
    syncStickyPrice();
  }

  // Build-Karte
  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-anvil-build]');
    if (!card) return;
    var box = card.closest('[data-anvil-buybox]');
    if (!box) return;
    event.preventDefault();

    var plateInput = document.getElementById(card.getAttribute('data-plate-input'));
    var switchInput = document.getElementById(card.getAttribute('data-switch-input'));
    if (!plateInput || !switchInput) return;

    track('build_selected', { build: card.getAttribute('data-anvil-build') });
    modus = 'builds';
    lastBuild = card.getAttribute('data-anvil-build');
    presetForm(box, box.getAttribute('data-keycaps'), plateInput.getAttribute('data-anvil-plate'), switchInput.getAttribute('data-anvil-switch'));
    selectInputs([plateInput, switchInput]);
  });

  // Keycaps (den Wechsel selbst macht Impact)
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.matches && input.matches('[data-anvil-buybox] input[data-anvil-keycaps]')) {
      track('keycaps_selected', { keycaps: input.getAttribute('data-anvil-keycaps') });
    }
  });

  // Plate und Switch im Reiter „Selbst zusammenstellen“ (Radios). Build-Karten setzen sie programmatisch,
  // das zählt nicht doppelt (Flag in selectInputs).
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (programmatisch || !input || !input.matches) return;
    if (input.matches('[data-anvil-buybox] input[data-anvil-plate]')) {
      track('plate_selected', { plate: input.getAttribute('data-anvil-plate') });
    } else if (input.matches('[data-anvil-buybox] input[data-anvil-switch]')) {
      track('switch_picked', { 'switch': input.getAttribute('data-anvil-switch'), from: 'selbst' });
    }
  });

  // Gehäusewechsel führt auf ein anderes Produkt, also eine neue Seite. Vor dem Sprung merken,
  // auf der Zielseite als case_color_selected melden (Shopify.analytics ist dort erst kurz nach dem Laden da).
  function buildInfo(box) {
    try {
      var script = box && box.querySelector('script[data-anvil-build-info]');
      return script ? JSON.parse(script.textContent) : {};
    } catch (e) { return {}; }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-anvil-buybox] [data-anvil-color-link]');
    if (!link || link.getAttribute('aria-current') === 'true') return;
    try {
      sessionStorage.setItem('anvil_case_switch', JSON.stringify({
        from: buildInfo(root()).gehaeuse || '',
        to: link.getAttribute('aria-label') || ''
      }));
    } catch (e) {}
  });
  function caseSwitchArrived(versuch) {
    var box = root();
    if (!box) return;
    var raw = null;
    try { raw = sessionStorage.getItem('anvil_case_switch'); } catch (e) {}
    if (!raw) return;
    var bereit = window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function';
    if (!bereit && (versuch || 0) < 20) { setTimeout(function () { caseSwitchArrived((versuch || 0) + 1); }, 250); return; }
    try { sessionStorage.removeItem('anvil_case_switch'); } catch (e) {}
    try {
      var data = JSON.parse(raw);
      track('case_color_selected', { 'case': buildInfo(box).gehaeuse || data.to || '', from: data.from || '' });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { caseSwitchArrived(0); });
  else caseSwitchArrived(0);

  // Switch-Tester-Karte: auf/zu über das Neu-Rendern halten, Öffnen tracken
  var testerOpen = false;

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('[data-anvil-tester] > summary');
    if (!summary) return;
    var details = summary.parentElement;
    setTimeout(function () {
      testerOpen = details.open;
      if (details.open) track('tester_offer_opened', {});
    }, 0);
  });

  function syncTesterOpen() {
    var box = root();
    var details = box && box.querySelector('[data-anvil-tester]');
    if (details && details.open !== testerOpen) details.open = testerOpen;
  }

  // Eigenes Formular (Impacts product-form): Impact öffnet danach den Warenkorb. Hier nur Rückmeldung in der Karte.
  function testerStatus(form, text) {
    var status = form.querySelector('[data-anvil-tester-status]');
    if (!status) return;
    status.textContent = text;
    status.hidden = !text;
  }

  document.addEventListener('variant:add', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('[data-anvil-tester]')) return;
    testerStatus(form, '');
    track('tester_added', {});
  });

  document.addEventListener('cart:error', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('[data-anvil-tester]')) return;
    testerStatus(form, (event.detail && event.detail.error) || '');
  });

  // Switch-Drawer („Switches vergleichen“ und ⓘ bei den Switches): die Switch-Karten der Seite beim Öffnen
  // hineinkopieren (immer frisch, der Block wird nach jeder Auswahl neu gerendert) und je Karte „Diesen nehmen“
  // ergänzen. Ohne Switch-Karten-Section bleiben Link und ⓘ versteckt (das ⓘ nur, wenn es keinen Text gibt).
  function switchCards() {
    return document.querySelector('.shopify-section--anvil-switch-cards .anvil-switches');
  }

  function syncInfoButtons() {
    var cards = switchCards();
    document.querySelectorAll('[data-anvil-buybox] [data-anvil-info-switches][hidden]').forEach(function (button) {
      if (cards) button.hidden = false;
    });
  }

  function slug(text) {
    return (text || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  // Radio zum Kartennamen: „Silent Red“ findet „cherry-mx2a-silent-red“
  function switchInputFor(box, name) {
    var needle = slug(name);
    if (!needle) return null;
    var inputs = box.querySelectorAll('input[data-anvil-switch]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('data-anvil-switch').indexOf(needle) !== -1) return inputs[i];
    }
    return null;
  }

  function fillSwitchDrawer(body, box) {
    var cards = switchCards();
    if (!body || !cards) return;

    var copy = cards.cloneNode(true);
    copy.querySelectorAll('[data-shopify-editor-block], [id]').forEach(function (el) {
      el.removeAttribute('data-shopify-editor-block');
      el.removeAttribute('id');
    });

    copy.querySelectorAll('.anvil-switch').forEach(function (card) {
      var nameEl = card.querySelector('.anvil-switch__name');
      var input = box && nameEl ? switchInputFor(box, nameEl.getAttribute('data-anvil-name') || nameEl.textContent) : null;
      if (!input) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--sm button--secondary anvil-switch__nehmen';
      if (input.checked) {
        button.textContent = body.getAttribute('data-picked-label') || 'Ausgewählt';
        button.disabled = true;
        card.classList.add('is-gewaehlt');
      } else {
        button.textContent = body.getAttribute('data-pick-label') || 'Diesen nehmen';
        button.setAttribute('data-anvil-pick-switch', input.id);
      }
      (card.querySelector('.anvil-switch__unten') || card).appendChild(button);
    });

    // Dezenter Scroll-Hinweis unten im Drawer: verschwindet, sobald das Listenende sichtbar ist
    var ende = document.createElement('div');
    ende.className = 'anvil-scrollhint__ende';
    var hinweis = document.createElement('div');
    hinweis.className = 'anvil-scrollhint';
    hinweis.setAttribute('aria-hidden', 'true');
    hinweis.innerHTML = '<span class="anvil-scrollhint__text"></span>' +
      '<svg class="anvil-scrollhint__pfeil" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    hinweis.firstChild.textContent = body.getAttribute('data-scroll-label') || 'Weitere Switches';

    body.replaceChildren(copy, ende, hinweis);

    if ('IntersectionObserver' in window) {
      if (body._anvilBeobachter) body._anvilBeobachter.disconnect();
      body._anvilBeobachter = new IntersectionObserver(function (eintraege) {
        hinweis.classList.toggle('is-fertig', eintraege[0].isIntersecting);
      });
      body._anvilBeobachter.observe(ende);
    } else {
      hinweis.classList.add('is-fertig');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-anvil-buybox] .anvil-info-button, [data-anvil-buybox] [data-anvil-info-switches]');
    if (!button) return;
    var isSwitches = button.hasAttribute('data-anvil-info-switches');
    track(isSwitches ? 'switch_drawer_opened' : 'info_opened', {
      from: button.classList.contains('anvil-info-button') ? 'info' : 'compare'
    });
    if (!isSwitches) return;

    var drawer = document.getElementById(button.getAttribute('aria-controls'));
    fillSwitchDrawer(drawer && drawer.querySelector('[data-anvil-info-switches-body]'), button.closest('[data-anvil-buybox]'));
  });

  // „Diesen nehmen“: passender Build, sonst Switch im Selbstbau (Plate bleibt). Drawer erst schließen, dann wählen:
  // Impact rendert danach den Kaufbereich samt Drawer neu.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-anvil-pick-switch]');
    if (!button) return;
    var box = root();
    var input = document.getElementById(button.getAttribute('data-anvil-pick-switch'));
    if (!box || !input) return;

    var drawer = button.closest('x-drawer');
    var closing = drawer && typeof drawer.hide === 'function' ? drawer.hide() : null;

    Promise.resolve(closing).then(function () {
      var switchValue = input.getAttribute('data-anvil-switch');
      track('switch_picked', { 'switch': switchValue, from: 'compare' });

      // Im Reiter „Selbst zusammenstellen“ bleiben, auch wenn ein Build denselben Switch hat
      var imSelbst = (modus || (box.getAttribute('data-build') === '' ? 'selbst' : 'builds')) === 'selbst';
      var card = imSelbst ? null : box.querySelector('[data-anvil-build][data-switch-input="' + input.id + '"]');
      if (card) {
        card.click();
        return;
      }

      chooseModus(box, 'selbst');
      presetForm(box, box.getAttribute('data-keycaps'), box.getAttribute('data-plate'), switchValue);
      selectInputs([input]);
    });
  });

  document.addEventListener('variant:change', function () {
    syncModus();
    syncTesterOpen();
    syncInfoButtons();
    syncUrlAndLinks();
    syncStickyPrice();
  });

  // Der Sticky-Balken wird von Impact eigenständig neu gerendert
  new MutationObserver(function () {
    if (root() || document.querySelector('[data-anvil-preis-oben]')) syncStickyPrice();
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSelection);
    document.addEventListener('DOMContentLoaded', syncStickyPrice);
  } else {
    initialSelection();
    syncStickyPrice();
  }
})();

/*
  Build speichern (snippets/anvil-build-save.liquid) → Klaviyo
  ----------------------------------------------------------------------------
  Nur nach aktivem Absenden mit Häkchen: Eintrag in die Liste über Klaviyos
  öffentliche Client-API (Double Opt-in, falls an der Liste eingestellt), der
  aktuelle Build als Profil-Eigenschaften und das Ereignis „Build gespeichert“
  (startet bei jedem Speichern den Flow für bereits bestätigte Kontakte; der
  erste Build läuft über den Listen-Trigger, siehe docs/HANDBUCH.md). Die Build-Daten kommen aus
  <script data-anvil-build-info> im Kaufbereich. Bewusst KEIN fertiger Link und
  keine Bild-URL: Die öffentliche API erlaubt jedem, Eigenschaften zu fremden
  Adressen zu setzen. Die Mail baut den Link darum fest auf nvil.gg aus
  build_handle und build_parameter (siehe docs/HANDBUCH.md).
  Impact rendert den Block nach jeder Variantenwahl neu: Offen-Zustand,
  Eingaben und Erfolg werden hier gemerkt und wiederhergestellt. Die
  Erfolgsmeldung gilt nur für den gespeicherten Build: Ändert sich danach die
  Auswahl, kommt das Formular mit E-Mail und Häkchen wieder (28.10.2026, vorher
  ging ein zweiter Build erst nach Neuladen der Seite).
*/
(function () {
  var REVISION = '2024-10-15';
  var state = { open: false, email: '', consent: false, done: false, saved: '' };

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  function buildInfo() {
    var script = document.querySelector('[data-anvil-buybox] script[data-anvil-build-info]');
    try {
      return script ? JSON.parse(script.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  // Nur die Auswahl-Parameter der aktuellen Adresse, z. B. „build=leise&keycaps=throwback“
  function parameter() {
    var current = new URL(window.location.href).searchParams;
    var out = new URLSearchParams();
    ['build', 'keycaps', 'plate', 'switch'].forEach(function (key) {
      if (current.get(key)) out.set(key, current.get(key));
    });
    return out.toString();
  }

  function properties() {
    var info = buildInfo();
    return {
      build_produkt: info.produkt || '',
      build_gehaeuse: info.gehaeuse || '',
      build_keycaps: info.keycaps || '',
      build_plate: info.plate || '',
      build_switch: info['switch'] || '',
      build_name: info.build || '',
      build_preis: info.preis || '',
      build_handle: info.handle || '',
      build_parameter: parameter(),
      build_gespeichert_am: new Date().toISOString()
    };
  }

  // Erkennungszeichen des aktuellen Builds (Auswahl in der Adresse + Variante/Preis), ohne Zeitstempel
  function signatur() {
    var info = buildInfo();
    return [info.handle || '', info.build || '', info.keycaps || '', info.plate || '', info['switch'] || '', info.preis || '', parameter()].join('|');
  }

  function post(path, key, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        accept: 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify(payload)
    });
  }

  function restore() {
    var details = document.querySelector('[data-anvil-save]');
    if (!details) return;
    if (state.done && state.saved !== signatur()) state.done = false;
    if (details.open !== state.open) details.open = state.open;
    var form = details.querySelector('[data-anvil-save-form]');
    var done = details.querySelector('[data-anvil-save-done]');
    if (form) {
      if (state.email && form.elements.email && !form.elements.email.value) form.elements.email.value = state.email;
      if (form.elements.consent) form.elements.consent.checked = state.consent;
      form.hidden = state.done;
    }
    if (done) done.hidden = !state.done;
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('[data-anvil-save] > summary');
    if (!summary) return;
    var details = summary.parentElement;
    setTimeout(function () {
      state.open = details.open;
      if (details.open) track('build_save_opened', {});
    }, 0);
  });

  document.addEventListener('input', function (event) {
    var form = event.target.closest && event.target.closest('[data-anvil-save-form]');
    if (!form) return;
    if (event.target.name === 'email') state.email = event.target.value;
  });

  document.addEventListener('change', function (event) {
    var form = event.target.closest && event.target.closest('[data-anvil-save-form]');
    if (form && event.target.name === 'consent') state.consent = event.target.checked;
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-anvil-save-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var key = form.getAttribute('data-key');
    var list = form.getAttribute('data-list');
    var email = form.elements.email.value.trim();
    var props = properties();
    var saved = signatur();
    var status = form.querySelector('[data-anvil-save-status]');
    var errorTemplate = form.parentElement.querySelector('template[data-anvil-save-error]');
    var button = form.querySelector('button[type="submit"]');
    if (status) status.hidden = true;
    if (button) button.setAttribute('aria-busy', 'true');

    var subscription = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.getAttribute('data-source') || 'Build speichern',
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    // Eigenschaften zusätzlich direkt am Profil setzen (auch wenn die Person schon auf der Liste steht)
    var profile = { data: { type: 'profile', attributes: { email: email, properties: props } } };
    // Ereignis mit demselben Build, damit Klaviyo jedes Speichern als eigenen Vorgang kennt
    var buildEvent = {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Build gespeichert' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    };

    post('subscriptions', key, subscription)
      .then(function (response) {
        if (!response.ok) throw new Error('subscription ' + response.status);
        return post('profiles', key, profile).catch(function () {});
      })
      .then(function () {
        // Nach den Eigenschaften, damit die Mail schon den neuen Build liest
        return post('events', key, buildEvent).catch(function () {});
      })
      .then(function () {
        state.done = true;
        state.saved = saved;
        track('build_saved', { build: props.build_name });
        restore();
      })
      .catch(function () {
        if (status) {
          status.textContent = errorTemplate ? errorTemplate.content.textContent.trim() : '';
          status.hidden = false;
        }
      })
      .then(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  });

  document.addEventListener('variant:change', restore);
})();

/*
  Bewertungszeile unter dem Produkttitel (snippets/anvil-rating.liquid)
  ----------------------------------------------------------------------------
  „236 Bewertungen“ springt zur Loox-Section der Seite. Deren Abschnitts-ID kennt das
  Theme nicht, deshalb wird sie hier über die Loox-Klassen gesucht. Ohne Treffer bleibt
  der normale Link (#shopify-product-reviews).
*/
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-anvil-zu-bewertungen]');
    if (!link) return;
    // Zuerst das eigentliche Bewertungs-Widget (Loox „Reviews widget“, klassisch oder v2), erst dann
    // andere Loox-Elemente wie das Galerie-Karussell im Kaufbereich (20.10.2026: das Karussell wurde
    // zuerst gefunden, der Klick „ging nirgends hin“, weil es in derselben Section liegt).
    var ziel = document.querySelector('#looxReviews, #shopify-product-reviews, .loox-reviews-default, [id^="LOOX-V2_REVIEWS"], .loox-v2-reviews-container')
      || document.querySelector('[class*="loox-v2"], [id*="LOOX-V2"]');
    if (!ziel) return;
    var section = ziel.closest('.shopify-section') || ziel;
    event.preventDefault();
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/*
  Pressestimmen „Laufzitat“ (sections/anvil-press.liquid)
  ----------------------------------------------------------------------------
  Die Fortschrittslinie unter dem aktiven Logo ist eine CSS-Animation. Ist sie
  durchgelaufen (animationend), wird das nächste Medium gewählt; die Linie des
  neuen Logos startet dann von selbst. Pause beim Überfahren regelt das CSS.
*/
(function () {
  document.addEventListener('animationend', function (event) {
    if (event.animationName !== 'anvil-press-lauf') return;
    var box = event.target.closest('[data-anvil-press-lauf]');
    if (!box) return;
    var radios = Array.prototype.slice.call(box.querySelectorAll('.anvil-press__radio'));
    if (radios.length < 2) return;
    var i = radios.findIndex(function (r) { return r.checked; });
    radios[(i + 1) % radios.length].checked = true;
  });
})();


/* ==========================================================================
   Bilder mit Text beim Scrollen (Builds, „Was bei dir ankommt“): Korrektur
   beim Hochscrollen (18.10.2026, Issue #212 Punkt 6/17)
   Impacts Scroll-Logik bricht nach dem ersten passenden Eintrag ab. Beim
   Hochscrollen bleibt deshalb ein späteres Bild (z. B. das grüne) über dem
   aktuellen stehen. Hier wird nach jedem Scroll-Frame der Soll-Zustand
   hergestellt: Bild n ist sichtbar, wenn Text n die gleiche Schwelle wie bei
   Impact (oberhalb von 90 % der Bildhöhe) erreicht hat, sonst nicht.
   ========================================================================== */
(function () {
  var sections = Array.from(document.querySelectorAll('images-with-text-scrolling[scrolling-experience]'));
  if (!sections.length) return;

  function zeigen(el, sichtbar, effekt) {
    var ziel = sichtbar
      ? { opacity: 1, clipPath: 'inset(0 0 0 0)' }
      : (effekt === 'fade' ? { opacity: 0 } : { opacity: 1, clipPath: 'inset(100% 0 0 0)' });
    var anim = el.animate([ziel], { duration: 250, easing: 'ease-out', fill: 'forwards' });
    anim.onfinish = function () {
      try { anim.commitStyles(); } catch (e) {}
      anim.cancel();
    };
  }

  function pruefen() {
    sections.forEach(function (sec) {
      var main = sec.querySelector('.images-scrolling-desktop__media-wrapper > :first-child');
      if (!main || !main.offsetParent) return;
      var bilder = sec.querySelectorAll('.images-scrolling-desktop__media-wrapper > :not(:first-child)');
      var texte = sec.querySelectorAll('.images-scrolling__content');
      var r = main.getBoundingClientRect();
      var schwelle = r.bottom - r.height * 0.1;
      var aktiv = 0;
      texte.forEach(function (t, i) { if (t.getBoundingClientRect().top < schwelle) aktiv = i; });
      var effekt = sec.getAttribute('scrolling-experience');
      bilder.forEach(function (bild, i) {
        var soll = i + 1 <= aktiv;
        if (soll !== bild.classList.contains('is-visible')) {
          bild.classList.toggle('is-visible', soll);
          zeigen(bild, soll, effekt);
        }
      });
      texte.forEach(function (t, i) {
        if (i === 0) return;
        var soll = i <= aktiv;
        var ist = parseFloat(getComputedStyle(t).opacity) > 0.5;
        if (soll !== ist) t.animate([{ opacity: soll ? 1 : 0 }], { duration: 250, fill: 'forwards' }).onfinish = function () {
          try { this.commitStyles(); } catch (e) {}
          this.cancel();
        };
      });
    });
  }

  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    // Ein Frame später, damit Impacts eigener Handler zuerst läuft und wir nur korrigieren
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { geplant = false; pruefen(); });
    });
  }
  window.addEventListener('scroll', planen, { passive: true });
  window.addEventListener('resize', planen);
})();

/* ==========================================================================
   Reiter eingeklappt (sections/tabs.liquid mit „ANVIL: Reiter eingeklappt
   starten“, 18.10.2026, Issue #212 Punkt 18)
   Startzustand „zu“ kommt als Klasse is-zu aus dem Liquid. Klick auf einen
   Reiter klappt auf (Impact wählt ihn wie gewohnt aus), Klick auf den schon
   offenen Reiter klappt wieder zu. Läuft in der Capture-Phase, damit der
   Zustand vor Impacts eigenem Klick-Handler gelesen wird.
   ========================================================================== */
(function () {
  document.querySelectorAll('x-tabs[data-anvil-eingeklappt]').forEach(function (tabs) {
    tabs.addEventListener('click', function (event) {
      var button = event.target.closest('.tabs-nav__button');
      if (!button || !tabs.contains(button)) return;
      var warOffen = button.getAttribute('aria-selected') === 'true' && !tabs.classList.contains('is-zu');
      tabs.classList.toggle('is-zu', warOffen);
      button.setAttribute('aria-expanded', warOffen ? 'false' : 'true');
    }, true);
  });
})();

/* ==========================================================================
   Galerie-Overlays nach Position (snippets/anvil-media-overlay.liquid,
   18.10.2026): Einträge ohne Bild im Produkt-Metafeld anvil.bild_overlays
   gelten für das 1., 2., 3. … SICHTBARE Galeriebild. Impact blendet Bilder
   beim Variantenwechsel per Skript aus (Attribut hidden), deshalb wird hier
   gezählt und bei jeder Änderung neu verteilt.
   ========================================================================== */
(function () {
  function verteilen(galerie) {
    var nr = 0;
    galerie.querySelectorAll('.product-gallery__media').forEach(function (bild) {
      if (!bild.hidden) nr += 1;
      bild.querySelectorAll('.anvil-overlay[data-anvil-nr]').forEach(function (o) {
        var aus = bild.hidden || o.getAttribute('data-anvil-nr') !== String(nr);
        if (o.hidden !== aus) o.hidden = aus; // nur bei Änderung, sonst triggert der Observer sich selbst
      });
    });
  }

  function beobachten(galerie) {
    if (galerie.__anvilOverlay) return;
    galerie.__anvilOverlay = true;
    verteilen(galerie);
    new MutationObserver(function (eintraege) {
      // Nur auf Änderungen an den Galeriebildern selbst reagieren, nicht auf die eigenen Overlays
      var relevant = eintraege.some(function (e) {
        return e.type === 'childList' || (e.target.classList && e.target.classList.contains('product-gallery__media'));
      });
      if (relevant) verteilen(galerie);
    }).observe(galerie, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
  }

  var geplant = false;
  function alle() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () {
      geplant = false;
      document.querySelectorAll('product-gallery').forEach(function (g) {
        if (g.querySelector('.anvil-overlay[data-anvil-nr]')) beobachten(g);
      });
    });
  }

  alle();
  // Galerie wird bei Variantenwechsel oder im Theme-Editor teils ersetzt
  document.addEventListener('shopify:section:load', alle);
  document.addEventListener('variant:change', alle);
})();

/* ==========================================================================
   Ratenzahlung (snippets/anvil-ratenzahlung.liquid, 19.10.2026)
   Liquid rendert die „Ab … € im Monat“-Zeile für die Startvariante. Bei
   jedem Variantenwechsel rechnet dieser Block mit dem neuen Preis nach
   (Annuität, gleiche Formel wie im Snippet) und blendet die Zeile aus, wenn
   der Preis außerhalb des Betragsfensters liegt. Nur Formulare derselben
   Section zählen, damit der Switch-Tester (featured-product) den Hinweis
   der NATIVE 75 nicht überschreibt.
   ========================================================================== */
(function () {
  function zahl(n) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fuellen(vorlage, werte) {
    return String(vorlage || '').replace(/\[(\w+)\]/g, function (treffer, key) {
      return key in werte ? werte[key] : treffer;
    });
  }
  function aktualisieren(box, cents) {
    var preis = cents / 100;
    var min = parseFloat(box.dataset.min) || 0;
    var max = parseFloat(box.dataset.max) || Infinity;
    var monate = parseInt(box.dataset.monate, 10) || 0;
    var soll = parseFloat(String(box.dataset.sollzins || '').replace(',', '.')) || 0;
    if (!monate || preis < min || preis > max) {
      box.hidden = true;
      return;
    }
    var i = soll / 1200;
    var rate = i > 0 ? (preis * i) / (1 - Math.pow(1 + i, -monate)) : preis / monate;
    rate = Math.round(rate * 100) / 100;
    var gesamt = Math.round(rate * monate * 100) / 100;
    var werte = {
      rate: zahl(rate),
      monate: String(monate),
      netto: zahl(preis),
      gesamt: zahl(gesamt),
      sollzins: box.dataset.sollzins || '',
      effzins: box.dataset.effzins || '',
      anbieter: box.dataset.anbieter || '',
      kreditgeber: box.dataset.kreditgeber || ''
    };
    var zeile = box.querySelector('[data-anvil-raten-zeile]');
    var hinweis = box.querySelector('[data-anvil-raten-hinweis]');
    if (zeile) zeile.textContent = fuellen(box.dataset.zeile, werte);
    if (hinweis) hinweis.textContent = fuellen(box.dataset.hinweis, werte);
    box.hidden = false;
  }

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant || typeof variant.price !== 'number') return;
    var form = detail.formId ? document.getElementById(detail.formId) : null;
    var section = form ? form.closest('.shopify-section') : null;
    document.querySelectorAll('[data-anvil-raten]').forEach(function (box) {
      if (section && box.closest('.shopify-section') !== section) return;
      aktualisieren(box, variant.price);
    });
  });
})();

// ---- Externe Links im Header (20.10.2026) ----------------------------------------------------
// Shopify-Menüs kennen kein „in neuem Tab öffnen“. Links im Header, die auf eine andere Domain zeigen
// (z. B. WEBKONFIGURATOR → app.anvil.gg), bekommen target="_blank"; das Icon dazu kommt aus anvil-custom.css.
(function () {
  function markieren() {
    var header = document.querySelector('[id$="__header"]');
    if (!header) return;
    header.querySelectorAll('a[href^="http"]').forEach(function (a) {
      try {
        if (new URL(a.href).host !== window.location.host && !a.target) {
          a.target = '_blank';
          a.rel = 'noopener';
        }
      } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markieren);
  else markieren();
})();

// ---- Help-Scout-Beacon erst nach dem Kaufbereich (20.10.2026) ---------------------------------
// Der Chat-Knopf (App-Embed, Container #beacon-container) ist per CSS versteckt, bis <html> die Klasse
// anvil-beacon-an trägt. Startseite und Seiten mit Kaufbereich: ab 50 % der Seite gescrollt, danach bleibt er.
// Andere Seiten: sofort. Handy regelt das CSS (nie), Ausnahme Kontaktseite (Klasse anvil-beacon-immer). Kein Help-Scout-API-Aufruf nötig, die App lädt wie gehabt.
(function () {
  var html = document.documentElement;
  function an() { html.classList.add('anvil-beacon-an'); window.removeEventListener('scroll', pruefen); }
  function pruefen() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max <= 0 || (window.scrollY || window.pageYOffset) / max >= 0.5) an();
  }
  function start() {
    var pfad = window.location.pathname.replace(/\/+$/, '') || '/';
    // Kontaktseite: immer sichtbar, auch auf dem Handy (Klasse hebt die Handy-Regel im CSS auf)
    if (/\/pages\/contact$/.test(pfad)) { html.classList.add('anvil-beacon-immer'); an(); return; }
    // Startseite und Seiten mit Kaufbereich: erst ab 50 % Scroll
    var gebremst = pfad === '/' || !!document.querySelector('[data-anvil-buybox]');
    if (!gebremst) { an(); return; }
    window.addEventListener('scroll', pruefen, { passive: true });
    pruefen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
